<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__supplier><div class="table-default__left">Supplier</div></template>
      <template #supplier="{ row }">
        <div class="table-default__left">
          <router-link
            v-if="row.supplier"
            :to="{ name: 'administrative-suppliers-detail-purchases', params: { id: row.supplier.id } }"
            class="table-default__link-inline"
          >
            {{ row.supplier.legal_name }}
          </router-link>
          <template v-else>-</template>
        </div>
      </template>
      <template #date="{ row }">{{ formatDate(row.date) }}</template>
      <template #amount="{ row }">{{ amountFormat(row.amount_total) }}</template>
      <template #vat_exclude="{ row }">{{ amountFormat(row.amount_excluded_vat) }}</template>
      <template #vat="{ row }">{{ amountFormat(row.amount_vat) }}</template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableDetailMissingEfd',
  props: ['tableItems', 'tablePreloader', 'pagination', 'formatDate', 'amountFormat'],
  data() {
    return {
      table: {
        columns: [
          'verification_code',
          'date',
          'supplier',
          'amount',
          'vat_exclude',
          'vat',
        ],
        options: {
          headings: {
            'verification_code': 'Verification Code',
            'date': 'Date',
            'supplier': 'Supplier',
            'amount': 'Total amount',
            'vat_exclude': 'VAT Exclude',
            'vat': 'VAT',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>

